export const TableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: 'Código',
                    type: 'text',
                    key: 'id',
                    isVisible: true,
                },
                {
                    title: 'Alcance',
                    type: 'text',
                    key: 'scope',
                    isVisible: true,
                },
                {
                    title: 'Area',
                    type: 'custom-html',
                    key: 'area',
                    isVisible: true,
                    modifier: (item) => {
                        return item.name
                    }
                },
            ],
            actionObj: {
                title: 'Acciones',
                type: 'action',
            }
        }
    },
}